// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"b699a0e1","81":"27d3ca52","119":"3965adda","334":"a9482682","815":"85451b4f","879":"f59f77d7"}[chunkId] + ".chunk.js";
};